export default "__VITE_ASSET__WM3_YsQ6__"